const GuidelineCard = ({ name, description }) => (
	<div className="guideline-card">
		<h3>{name}</h3>
		<p>{description}</p>
	</div>
);

export default GuidelineCard;
